import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetWeixinConfigParams extends ActiomCommonParams {
    token: string | number;
}

interface QuotaDetail {
    original_quota: number;
    quota: number;
    str_date: string;
}

interface QuotaDetailResponse {
    base_resp: { err_msg: string; ret: number };
    quota_detail_list: { quota_item_list: QuotaDetail; quota_type: string }[];
}

export interface ConfigData {
    publishQuota: QuotaDetail[];
}

export type PublishAction = CommonAction<GetWeixinConfigParams, ConfigData>;

export const getWeixinConfig: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        },
    });
    const fingerprint = "4695500bc93ab4ce8fb2692da6564e04";

    const res = await http.api<QuotaDetailResponse>({
        method: "get",
        url: "https://mp.weixin.qq.com/cgi-bin/masssendpage",
        params: {
            f: "json",
            token: params.token,
            lang: "zh_CN",
            ajax: 1,
            fingerprint: fingerprint,
            random: Math.random().toString(),
        },
    });
    const filtered = {
        publishQuota:
            res.base_resp.ret === 0
                ? res.quota_detail_list
                      .filter((item) => item.quota_type === "kQuotaTypeMassSendNormal")
                      .map((item) => item.quota_item_list)
                : [],
    };
    return success(filtered, res.base_resp.ret === 0 ? "微信配置信息获取成功！" : "微信配置信息获取失败！");
};
